import PastGrantWinnersList from './PastGrantWinnersList';

export default PastGrantWinnersList;
